export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7577.ce3b0d7f.jpg";